import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Sidebar } from './components/layout/Sidebar';
import { Overview } from './pages/Overview';
import { ProposalsBoard } from './pages/ProposalsBoard';
import { ProposalDetail } from './components/proposals/ProposalDetail';
import { PropertiesBoard } from './pages/PropertiesBoard';
import { LeadsBoard } from './pages/LeadsBoard';
import { SocialPlanner } from './pages/SocialPlanner';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mmcd05ohp6ap">
      <div className="flex h-screen w-full overflow-hidden bg-[#f5f6f8]" data-id="element-1" data-mp="2mmvkesgikcah">
        <Sidebar data-id="element-2" data-mp="31b8jvzet8d9q" />
        <main className="mp-scroll flex flex-1 flex-col overflow-y-auto" data-id="element-3" data-mp="31bs1ff0jszn8">
          <Routes data-id="element-4" data-mp="2wk9xqj754kyk">
            <Route path="/" element={<Overview data-id="element-6" data-mp="2wifgpfyzpczr" />} data-id="element-5" data-mp="2wiyxuugtfxcq" />
            <Route path="/proposals" element={<ProposalsBoard data-id="element-8" data-mp="28tw9l3rof699" />} data-id="element-7" data-mp="2wi5lndz38fn7" />
            <Route path="/proposals/:id" element={<ProposalDetail data-id="element-10" data-mp="23vcjcr61v8b3" />} data-id="element-9" data-mp="28sutgkvsztko" />
            <Route path="/properties" element={<PropertiesBoard data-id="element-12" data-mp="23v2r0wxj8p28" />} data-id="element-11" data-mp="23w4ey1znd61d" />
            <Route path="/leads" element={<LeadsBoard data-id="element-14" data-mp="3ikqytzf4l45q" />} data-id="element-13" data-mp="3ijxoypkvdyjd" />
            <Route path="/social" element={<SocialPlanner data-id="element-16" data-mp="3ii4ppvcl6gle" />} data-id="element-15" data-mp="3ijfthv617oci" />
          </Routes>
        </main>
      </div>
    </BrowserRouter>;
}